type ProjectExternalLink = {
  url: string;
  name: string;
  icon: string;
  index: number;
};

const projectExternalLink: ProjectExternalLink = {
  url: "",
  name: "",
  icon: "",
  index: 0 | 1 | 2 | 3,
};

export type { ProjectExternalLink };

export { projectExternalLink };
